import { ChameleonQueueStatus } from '@/@types/generated'
import { register } from './enum'

export const ChameleonQueueStatusTextColor: Record<
  ChameleonQueueStatus,
  string
> = {
  [ChameleonQueueStatus.PENDING_REVIEW]: 'text-purple-400',
  [ChameleonQueueStatus.CLEARED]: 'text-green-400',
  [ChameleonQueueStatus.CONFIRMED_FRAUD]: 'text-red-500',
}

export const ChameleonQueueStatusLabels: Record<ChameleonQueueStatus, string> =
  {
    [ChameleonQueueStatus.PENDING_REVIEW]: 'Pending',
    [ChameleonQueueStatus.CLEARED]: 'Cleared',
    [ChameleonQueueStatus.CONFIRMED_FRAUD]: 'Confirmed Fraud',
  }

register<ChameleonQueueStatus>(ChameleonQueueStatus, (v) => {
  if (!v) return '\u2014'
  return ChameleonQueueStatusLabels[v]
})
